import { Group, Text } from "@mantine/core";
import { IconCheck, IconX } from "@tabler/icons-react";

interface MatchIndicatorsProps {
  dateMatches: boolean;
  locationMatches: boolean;
}

export const MatchIndicators = ({ dateMatches, locationMatches }: MatchIndicatorsProps) => {
  return (
    <Group gap="xs">
      <Text c="gray" size="xs">
        장소:
      </Text>
      {locationMatches ? <IconCheck color="green" size={16} /> : <IconX color="red" size={16} />}
      <Text c="gray" size="xs">
        날짜:
      </Text>
      {dateMatches ? <IconCheck color="green" size={16} /> : <IconX color="red" size={16} />}
    </Group>
  );
};

